import { graphql } from '../../graphql';

export const editingItemQuery = graphql(`
  query EditingItem($itemId: ID!) {
    itemEdit(itemId: $itemId) {
      item {
        title
        isLeased
        location {
          fullName
        }
        category {
          id
        }
      }
      edit {
        area {
          units
          value
        }
        contactName
        description
        floor
        floors
        hasBillOfSale
        hasMortgage
        hasRepair
        landArea {
          units
          value
        }
        paidDaily
        photos {
          thumbnail
        }
        price {
          currency
          total
        }
        rooms
      }
    }
  }
`);
